import axios from 'axios';

export default {
  findAllFrontal(ctx) {
    return axios.get(api_url + user_role + "/packs/order-kitchen", {
      params: {ctx: ctx}
    });
  },
  findById(id) {
    return axios.get(api_url + user_role + "/packs/" + id);
  },
  findByCode(pack_code) {
    return axios.get(api_url + user_role + "/packs/order-kitchen-all", {
      params: {
        pack_code: pack_code
      }
    });
  },
  findAllElectros() {
    console.log(api_url);
    console.log(user_role);
    return axios.get(api_url + user_role + "/packs/products-magento");
  },
  findElectro(sku) {
    return axios.get(api_url + user_role + "/packs/single-product-magento", {
      params: {
        sku: sku
      }
    });
  },
  createProject(params) {
    return axios.post(api_url + user_role + "/packs/create-project", params);
  },
  bookEvent(params) {
    return axios.post(api_url + user_role + "/packs/book-event", params);
  },
  getCustomer(userId) {
    return axios.get(base_url + 'rest/default/V1/customers/' + userId + '', {
      headers: {
        'Authorization': 'Bearer ekydnhfjv69qslao2j9843umhusv5cbg'
      }
    }).then(response => {
      // Procesa los datos del usuario en la respuesta
      const userData = response.data;
      return userData;
      // Haz algo más con los datos del usuario
    }).catch(error => {
      // Maneja el error de la solicitud
    });
    //return userData;
  }
};



// WEBPACK FOOTER //
// ./src/api/packfrontal.js